import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import type { components } from "@/types/api";

export type Letterhead = components["schemas"]["LetterheadSettings"];

const key = ["organization", "letterhead"] as const;

export function useLetterhead() {
  return useQuery({
    queryKey: key,
    queryFn: async () => {
      const { data, error } = await apiClient.GET(
        "/api/v1/organizations/me/letterhead",
        {},
      );
      if (error || !data) throw new Error("Failed to load letterhead");
      return data;
    },
  });
}

export function useUpdateLetterhead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (body: Letterhead) => {
      const { data, error } = await apiClient.PUT(
        "/api/v1/organizations/me/letterhead",
        { body },
      );
      if (error || !data) throw new Error("Failed to save letterhead");
      return data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: key }),
  });
}
